import React from "react";
import { UseFormReturn } from "react-hook-form";
import { PurchaseApi, TaxItemApi } from "../../../../../../../../../../../../services/Api/Organization/types";
import PurchaseFormItemsSummaryTableBody from "./PurchaseFormItemsSummaryTableBody";
import PurchaseFormItemsSummaryTableHeader from "./PurchaseFormItemsSummaryTableHeader";

interface Props {
	summaryTaxes: TaxItemApi[];
	exchangeRateLoading: boolean;
	form: UseFormReturn<PurchaseApi>;
	exchangeRate: number;
}

const PurchaseFormItemsSummaryTable = ({ summaryTaxes, form, exchangeRateLoading, exchangeRate }: Props) => {
	return (
		<div className="table-responsive">
			<table className="table table-preview mt-3">
				<PurchaseFormItemsSummaryTableHeader />
				<PurchaseFormItemsSummaryTableBody
					summaryTaxes={summaryTaxes}
					exchangeRateLoading={exchangeRateLoading}
					form={form}
					exchangeRate={exchangeRate}
				/>
			</table>
		</div>
	);
};

export default PurchaseFormItemsSummaryTable;
